"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var route_utils_1 = require("./route-utils");
var Callback_component_1 = __importDefault(require("../default-component/Callback.component"));
var SilentCallback_component_1 = __importDefault(require("../default-component/SilentCallback.component"));
var ServiceWorkerInstall_component_1 = __importDefault(require("../default-component/ServiceWorkerInstall.component"));
var defaultProps = {};
var OidcRoutes = function (_a) {
    var callbackErrorComponent = _a.callbackErrorComponent, callbackSuccessComponent = _a.callbackSuccessComponent, authenticatingComponent = _a.authenticatingComponent, redirect_uri = _a.redirect_uri, silent_redirect_uri = _a.silent_redirect_uri, children = _a.children, configurationName = _a.configurationName, _b = _a.withCustomHistory, withCustomHistory = _b === void 0 ? null : _b;
    // This exist because in next.js window outside useEffect is null
    var pathname = window ? (0, route_utils_1.getPath)(window.location.href).split("?")[0] : '';
    var _c = (0, react_1.useState)(pathname), path = _c[0], setPath = _c[1];
    (0, react_1.useEffect)(function () {
        var setNewPath = function () { return setPath((0, route_utils_1.getPath)(window.location.href).split("?")[0]); };
        setNewPath();
        window.addEventListener('popstate', setNewPath, false);
        return function () { return window.removeEventListener('popstate', setNewPath, false); };
    }, []);
    var callbackPath = (0, route_utils_1.getPath)(redirect_uri);
    if (silent_redirect_uri) {
        if (path === (0, route_utils_1.getPath)(silent_redirect_uri)) {
            return react_1.default.createElement(SilentCallback_component_1.default, { configurationName: configurationName });
        }
    }
    switch (path) {
        case callbackPath:
            return react_1.default.createElement(Callback_component_1.default, { callBackError: callbackErrorComponent, callBackSuccess: callbackSuccessComponent, configurationName: configurationName, withCustomHistory: withCustomHistory });
        case callbackPath + "/service-worker-install":
            return react_1.default.createElement(ServiceWorkerInstall_component_1.default, { callBackError: callbackErrorComponent, authenticating: authenticatingComponent, configurationName: configurationName });
        default:
            return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
};
// @ts-ignore
OidcRoutes.defaultProps = defaultProps;
exports.default = react_1.default.memo(OidcRoutes);
//# sourceMappingURL=OidcRoutes.js.map